import React from "react";

// Admin Imports
import MainDashboard from "views/admin/default";
import NFTMarketplace from "views/admin/users";
import Profile from "views/admin/account-verification";
import DataTables from "views/admin/tables";
import { BiSolidReport } from "react-icons/bi";

// Auth Imports
import SignIn from "views/auth/SignIn";

// Icon Imports
import { MdHome, MdBarChart, MdPerson, MdLock, MdCast } from "react-icons/md";
import SocialPosts from "views/admin/users copy";
import { FaUsers } from "react-icons/fa";
import BatchVerify from "views/admin/batch-verification";
import Reports from "views/admin/reports";
import Details from "views/admin/reports/Details";
import Marketplace from "views/admin/marketplace";
import { FaStore } from "react-icons/fa";
import LiveStreamRequest from "views/admin/livestream-request";
import { FaVideo } from "react-icons/fa";
import VerificationBadgeRequest from "views/admin/verification-badge-request";
import { FaCheckCircle } from "react-icons/fa";
import ProductCategories from "views/admin/product-categories";
import { MdCategory, MdConfirmationNumber } from "react-icons/md";
import Promotion from "views/admin/promotion";
import AudioRoom from "views/admin/audio-room";

const routes = [
  {
    name: "Sign In",
    layout: "/auth",
    path: "sign-in",
    icon: <MdLock className="h-6 w-6" />,
    component: <SignIn />,
  },
  {
    name: "Dashboard",
    layout: "/",
    path: "dashboard",
    icon: <MdHome className="h-6 w-6" />,
    component: <MainDashboard />,
  },
  {
    name: "Users",
    layout: "/",
    path: "users",
    icon: <FaUsers className="h-6 w-6" />,
    component: <NFTMarketplace />,
    secondary: true,
  },
  {
    name: "Accounts",
    layout: "/",
    path: "account-verification",
    icon: <MdPerson className="h-6 w-6" />,
    component: <Profile />,
  },
  {
    name: "Posts",
    layout: "/",
    icon: <MdBarChart className="h-6 w-6" />,
    path: "social-posts",
    component: <SocialPosts />,
  },
  {
    name: "Offers & Pricing",
    layout: "/",
    icon: <MdConfirmationNumber className="h-6 w-6" />,
    path: "promotion",
    component: <Promotion />,
  },
  {
    name: "Live Stream & Audio Room",
    layout: "/",
    icon: <MdCast className="h-6 w-6" />,
    path: "audio-room",
    component: <AudioRoom />,
  },
  {
    name: "LiveStream Request",
    layout: "/",
    icon: <FaVideo className="h-6=5 w-5" />,
    path: "livestream-request",
    component: <LiveStreamRequest />,
  },
  {
    name: "Verification Badge Request",
    layout: "/",
    icon: <FaCheckCircle className="h-5 w-5" />,
    path: "verification-badge-request",
    component: <VerificationBadgeRequest />,
  },
  {
    name: "Marketplace",
    layout: "/",
    icon: <FaStore className="h-5 w-5" />,
    path: "marketplace",
    component: <Marketplace />,
  },
  {
    name: "Product Categories",
    layout: "/",
    icon: <MdCategory className="h-6 w-6" />,
    path: "product-categories",
    component: <ProductCategories />,
  },
  {
    name: "Reports",
    layout: "/",
    icon: <BiSolidReport className="h-5 w-5" />,
    path: "reports",
    component: <Reports />,
  },
  
 
  // {
  //   name: "Report Details",
  //   layout: "/",
  //   icon: <BiSolidReport className="h-5 w-5" />,
  //   path: "reports/:id",
  //   component: <Details />,
  // },
  // {
  //   name: "Batch Verification",
  //   layout: "/",
  //   path: "batch-verification",
  //   icon: <MdPerson className="h-6 w-6" />,
  //   component: <BatchVerify />,
  // },
];
export default routes;
